module.exports = __webpack_public_path__ + "static/AIretouchicon-700c264e0cd4665e68ed3ae378995151.png";